import Vue from 'vue'
import paycoupon from './paycoupon.vue'
import '../base/common'

new Vue({
  data() {
    return {
      state: {}
    }
  },
  created() {
    Vue.prototype.$state = this.state
  },
  render: h => h(paycoupon)
}).$mount('#app')
